const TOKEN_KEY = "superShineToken";
const USERNAME_KEY = "username";
const EMAIL_KEY = "email";

export const getAuthToken = () => sessionStorage.getItem(TOKEN_KEY);
export const getAuthEmail = () => sessionStorage.getItem(EMAIL_KEY);

export const setAuthSession = ({ accessToken, username, email }) => {
  sessionStorage.setItem(TOKEN_KEY, accessToken);
  sessionStorage.setItem(USERNAME_KEY, username || "");
  sessionStorage.setItem(EMAIL_KEY, email || "");
};

export const clearAuthSession = () => {
  sessionStorage.removeItem(TOKEN_KEY);
  sessionStorage.removeItem(USERNAME_KEY);
  sessionStorage.removeItem(EMAIL_KEY);
};
